import { create } from 'zustand';

interface ImageStore {
    imageData: Record<string, any[]>;
    setImageData: (id: string, imageList: any[]) => void;
    addImage: (id: string, image: any) => void;
    removeImage: (id: string, imageUrl: string) => void;
    reset: () => void;
}

export const useMultipleImageStore = create<ImageStore>(
    (set) => ({
        imageData: {},
        setImageData: (id, imageList) => set((state) => {
            // Solo actualiza el estado si realmente hay un cambio
            if (JSON.stringify(state.imageData[id]) !== JSON.stringify(imageList)) {
                return {
                    imageData: { ...state.imageData, [id]: imageList }
                };
            }
            return state;
        }),
        addImage: (id, image) => set((state) => {
            const currentList = state.imageData[id] || [];
            return { imageData: { ...state.imageData, [id]: [...currentList, image] } };
        }),
        removeImage: (id, imageUrl) => set((state) => {
            const currentList = state.imageData[id] || [];
            return { imageData: { ...state.imageData, [id]: currentList.filter(img => img.url !== imageUrl) } };
        }),
        reset: () => set(() => ({
            imageData: {}
        }))
    })
);
